import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { tierApi } from "../services/tierApi";
import GolfersCard from "../components/golfers/GolfersCard";
import './Golfers.css';

const TIERS = ["TIER_A", "TIER_B", "TIER_C", "TIER_D"];

const Golfers = () => {
  const navigate = useNavigate();
  const [tiers, setTiers] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [article1, setArticle1] = useState("<p>First editor</p>");
  const [article2, setArticle2] = useState("<p>Second editor</p>");

  useEffect(() => {
    loadAllTiers();
  }, []);

  const loadAllTiers = async () => {
    setLoading(true);
    setError(null);

    try {
      // Fetch all 4 tiers in parallel
      const results = await Promise.all(
        TIERS.map(tier => tierApi.getGolfersByTier(tier))
      );

      // Build an object: { TIER_A: [...], TIER_B: [...], ... }
      const tierData = {};
      TIERS.forEach((t, i) => {
        tierData[t] = Array.isArray(results[i]) ? results[i] : [];
      });

      setTiers(tierData);
    } catch (err) {
      console.error("Error loading tiers:", err);
      setError("Unable to load golfers. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="proskins-content golfers-proskins-main">

      <div style={{marginBottom: 'var(--spacing-2xl)'}}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 'var(--spacing-sm)'
        }}>
          <h1 className="proskins-section-title" style={{margin: 0}}>Golfers</h1>
          <button
            className="proskins-btn proskins-btn-outline"
            onClick={() => navigate('/')}
          >
            ← Back to Homepage
          </button>
        </div>
      </div>

      {loading ? (
        <div>Loading golfers...</div>
      ) : error ? (
        <div className="proskins-alert proskins-alert-warning">{error}</div>
      ) : (
        <div className="golfers-cards">
          <GolfersCard title="A tier" tier="A" golfers={tiers.TIER_A || []}/>
          <GolfersCard title="B tier" tier="B" golfers={tiers.TIER_B || []}/>
          <GolfersCard title="C tier" tier="C" golfers={tiers.TIER_C || []}/>
          <GolfersCard title="D tier" tier="D" golfers={tiers.TIER_D || []}/>
        </div>
      )}
    </div>
  );
};

export default Golfers;